// This helper function prevents empty/null/undefined params to show up in an event.
// This makes sure that only relevant data is sent to Google Analytics.
// Note that [_, value] would (in this context) mean [key, value], but _ indicates any variable that is not going to be used.
type FilterableValue = string | number | boolean | Date | null | undefined;

export const filterParams = (params: { [key: string]: FilterableValue }) =>
	Object.fromEntries(
		Object.entries(params).filter(
			([_, value]) => value != null && value !== '',
		),
	);
